import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import moment from 'moment';
import cookie from 'react-cookies';
import {API_URL, BASE_URL_CMS} from '../../../constants';
import ButtonLoader from '../../Elements/Button/button';
import axios from 'axios';
import $ from 'jquery';

import Error from '../../Error/error';

import Checkbox from '@material-ui/core/Checkbox';

export default class AsignarPagina extends Component {
    constructor(props) {
        super(props); 

        this.state = {
            pagina:         1,
            id:             this.props.match.params.id,
            loading:        true,
            data:           [],
            error:          [],
            roles:          [],
            response:       [],
            security:       cookie.load('user'),
            selectedPages:  [],
            search:         ""
        }

        this.getData = this.getData.bind(this);
    }

    paginationTable(){
        var entity = this.state.data.length > 0 ? this.state.data[0] : null;
        var maxPagination = 6;
  
        const options = [];
  
        if (entity !== null){
  
            if(entity.totalPages == 1){
                return null;
            }

            if(entity.totalPages < maxPagination){
                maxPagination = entity.totalPages;
            }

            let actualpage    = this.state.pagina;
            let rango         = Number(maxPagination) + Number(actualpage);
            let totalPages    = "";
  
            if(rango > entity.totalPages){
              rango = Number(entity.totalPages);
              actualpage = Number(entity.totalPages) - Number(maxPagination);
            }

            if(actualpage < 1){
                actualpage = 1;
            }
  
            if(actualpage > 1 && rango > 7){
              options.push(
                <a 
                    id={`inicio-pag`} 
                    key={`inicio-pag`} 
                    onClick={(e) => this.getData(`${1}`)}
                > 
                  ..
                </a>
              );
            }
  
            options.push(
                <a 
                    className="btnPrevPaginador" 
                    id={0} 
                    key={0} 
                    onClick={(e) => Number(this.state.pagina) <= 1 ? "" : this.getData(`${Number(this.state.pagina) - 1}`)}
                ></a>
            );
  
            // console.log(index);
            // console.log(rango);
  
            for(let i = actualpage; i <= rango; i++){
                console.log(i);
  
                options.push(
                    <a 
                        id={i} 
                        key={i} 
                        onClick={(e) => this.getData(`${i}`)}
                        className={(i.toString() === this.state.pagina.toString() ? "active" : "") + " pageItem"}
                    > 
                        {i} 
                    </a>
                );
            }
  
            options.push(
                <a 
                    className="btnNextPaginador" 
                    id={entity.totalPages+1} 
                    key={entity.totalPages+1} 
                    onClick={(e) => entity.totalPages.toString() === this.state.pagina.toString() ? "" : this.getData(`${Number(this.state.pagina) + 1}`)}
                ></a>
            );
  
            if(rango < entity.totalPages){
              options.push(
                <a 
                    id={entity.totalPages} 
                    key={entity.totalPages} 
                    onClick={(e) => this.getData(`${entity.totalPages}`)}
                > 
                  ..
                </a>
              );
            }
  
            console.log(options);
  
            return (
                <div className="divPaginador" key={"pagination"} id="pagination">
                    {options}
                </div>
            );
        }
    }

    componentDidMount(){
        this.getData(this.state.pagina);
    }

    select(event, id){
        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        // const id     = target.id;

        let actualSelectedList = [...this.state.selectedPages];

        if(!actualSelectedList.includes(id)){
            actualSelectedList.push(id);
        }else{
            actualSelectedList = actualSelectedList.filter((item) => item !== id);
        }

        this.setState({
            selectedPages: actualSelectedList
        });
    }

    handleClickCancel(){
        // const {history: {push}} = this.props;
        // window.location.href = BASE_URL_CMS + "/recurso";

        this.props.history.push({
            pathname: `/listar-pagina/usuario/${this.state.id}`,
        });
    }

    callFunctionButton = (event) => {

        let _isOk = true;

        if(this.state.selectedPages.length < 1){
            toast.error('Error en Validación: Seleccione al menos una página.');
            _isOk = false;
        }

        if(!_isOk){
            event.preventDefault();
            return;
        }

        let data = {
            usua_Id:        Number(this.state.id),
            paginas:        this.state.selectedPages,
            usua_creacion:  Number(this.state.security.nUsuCodigo)
        }

        const url = `${API_URL}PaginaUX/AsignarPaginaUsuario`;

        const formData = JSON.stringify(data);
        this.setState({
            loading:true
        });

        // console.log(formData);

        axios.post(
            url,
            JSON.stringify(formData),
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }
        ).then( data => {

            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");
            if (data.data.isSucess){
                toast.success(`${data.data.result.status}`);
                setTimeout(() => { 
                    //window.location.href = BASE_URL_CMS + `/listar-pagina/${this.state.security.nUsuCodigo}/${this.state.id}`
                    this.handleClickCancel();
                }, 1500);
            }else{
                this.setState({ 
                    loading:false 
                });
                toast.error('No se pudo registrar la página. \r');
            }

        }).catch((error)=> {

            toast.error('Error no controlado.');
            this.setState({
                loading:false
            });

        });
    }

    getData (page = "", textsearch = "") {
        if(document.querySelector('.loader').classList.contains('loader--hide')){
            document.querySelector('.loader').classList.remove('loader--hide');
            document.getElementById('content-wrapper').setAttribute("hidden", true);
        }

        console.log(page);

        if(page === ''){
            page = 1;
        }

        if(textsearch !== ""){
            textsearch = "/"+textsearch;
        }

        const url = `${API_URL}PaginaUX/${page}/${this.state.security.nUsuCodigo+textsearch}`;

        axios.get(url)
        .then(response => response.data)
        .then((data) => {
            console.log(data);

            this.setState({ 
                data:       data.result, 
                response:   data, 
                error:      data.Error,
                loading:    false,
                pagina:     page
            });

            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");

        }).catch(error => {
            document.querySelector('.loader').classList.add('loader--hide');
            toast.error('Error de comunicación');
        });
    }

    changeTextSearch = (e) => {
        e.preventDefault();
        const {value} = e.target;

        this.setState({
            search: value
        });
    }

    searchDataByText = (e) => {
        e.preventDefault();
        this.getData("1", this.state.search);
    }

    render(){
        console.log(this.state.selectedPages);

        moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        return (
            (this.state.response.statusCode == 200) ?
                <div>
                    <div id="detailBody" className="Site-content">
                        <div className="loader"></div>
                        <div hidden={true} id="content-wrapper">
                            <div id="content">
                                <div id="Body" className="body-container">

                                    <div className="divContenedorBreadcrumbs">
                                        <div className="divCenterBreadcrumbs">
                                            <img src="/static/images/icoBreadcrumb.png" alt />
                                            <a  href="/">
                                                / Panel de configuración general
                                            </a >
                                            <Link to="/permisos">
                                                / Usuarios
                                            </Link>
                                            <Link to="/usuarios">
                                                / Lista de usuarios
                                            </Link>
                                            <Link to={`/listar-pagina/usuario/${this.state.id}`}>
                                                / Páginas
                                            </Link>
                                            <span> / Asignar Páginas</span>
                                        </div>
                                    </div>

                                    <div className="divTitulo_Panel mb-3">
                                        Asignar Páginas
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-12 col-lg-10 mx-auto">

                                            <form action="" onSubmit={(e) => this.searchDataByText(e)}>
                                                <div className="divCatAnadir_Panel">
                                                    <div className="divSectorSearch_Panel w-100">
                                                        <input 
                                                            type="text"
                                                            placeholder="Encontrar página" 
                                                            id="busqueda" 
                                                            onChange={(e) => this.changeTextSearch(e)}
                                                        />
                                                        <input 
                                                            type="submit" 
                                                            defaultValue="Buscar" 
                                                            // onClick={(event) => this.callFunctionBuscar(event)}
                                                        />
                                                    </div>
                                                    <div className="clear" />
                                                </div>
                                            </form>

                                            <div className="divTablaPage_Panel">

                                                <div className="table-responsive">
                                                    <table border={1} cellSpacing={0}>
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    {/* 
                                                                        <Checkbox  
                                                                            name={`select-all-pages`} 
                                                                            id={`select-all-pages`} 
                                                                            onChange={(e) => this.selectAll(e)} 
                                                                            // value={this.state.resource.bPortada} 
                                                                            // placeholder="Cabecera" 
                                                                        />
                                                                    */}
                                                                </th>

                                                                <th>#</th>
                                                                <th>Título</th>
                                                                <th>Plantilla</th>

                                                                <th>Creación</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.data.length > 0 ? 
                                                                this.state.data.map((item, key) => {
                                                                    let isCheck = this.state.selectedPages.includes(item.pagi_Id);

                                                                    return <tr key={key}>
                                                                        <td>
                                                                            <Checkbox  
                                                                                name={`pagina-${item.pagi_Id}`} 
                                                                                id={`pagina-${item.pagi_Id}`} 
                                                                                onChange={(e) => this.select(e, item.pagi_Id)} 
                                                                                // value={isCheck} 
                                                                                checked={isCheck}
                                                                            />
                                                                        </td>

                                                                        <td>{item.pagi_Id}</td>
                                                                        <td style={{ maxWidth: "250px" }}>
                                                                            {item.pagi_Titulo}
                                                                        </td>
                                                                        <td>{item.plantilla}</td>
                                                        
                                                                        <td>{moment(item.pagi_FechaCreacion).format("dddd DD, MMMM YYYY")}</td>
                                                                    </tr>
                                                                })
                                                            :
                                                                <tr>
                                                                    <td colSpan={10}>
                                                                        Sin páginas asignadas para este usuario
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {this.state.data.length > 0 &&
                                                    <div>
                                                        {this.paginationTable()}
                                                        <div className="clear" />
                                                    </div>
                                                }

                                                <div>
                                                    <div className="row justify-content-center my-3">
                                                        <div className="col-md-5 justify-content-center d-flex">
                                                            <button 
                                                                type="button" 
                                                                onClick={(event) => this.handleClickCancel(event)} 
                                                                className="btn btn-default btn-primary__submit"
                                                            >
                                                                Cancelar
                                                            </button>
                                                            &nbsp;
                                                            <ButtonLoader 
                                                                text="GUARDAR" 
                                                                textProcessing="PROCESANDO..." 
                                                                loading={this.state.loading} 
                                                                callFunctionButton={(e) => this.callFunctionButton(e)}
                                                            ></ButtonLoader>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            :
            <Error StatusCode={this.state.response.StatusCode} StatusMessage={this.state.response.StatusMessage}></Error>
        )
    }

    /*
        addPage(){
            this.props.history.push({
                pathname: `/asignar-pagina/${this.state.security.nUsuCodigo}/${this.state.id}`,
                state: { key: this.state.id}
            });
        }
    */

    /*
        getPagesByUser (page = "") {
            const url = `${API_URL}PaginaUX/${page}/${this.state.id}`;

            axios.get(url)
            .then(response => response.data)
            .then((data) => {
                console.log(data);

                this.setState({ 
                    data:       data.result, 
                    response:   data, 
                    error:      data.Error,
                    loading:    false
                });
            }).catch(error => {

            });
        }
    */
}